module.exports = __webpack_public_path__ + "img/hero-paris@2x.5e75e3c9.webp";